import { Button } from "payzli-ui";
import packageJson from "payzli-ui/package.json";
import { useEffect, useState } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router";
import "./App.css";
import APP_LOGO from "./assets/logo.png";
import { Avatar, IconButton } from "./components";
import { enumRoutes } from "./utils/helper";
import AccordionSection from "./Views/AccordionSection";
import AvatarGroupSection from "./Views/AvatarGroupSection";
import AvatarSection from "./Views/AvatarSection";
import BadgeSection from "./Views/BadgeSection";
import BreadcrumbSection from "./Views/BreadcrumbSection";
import ButtonSection from "./Views/ButtonSection";
import CardSection from "./Views/CardSection";
import CheckboxSection from "./Views/CheckboxSection";
import DateRangePopup from "./Views/DateRangePopup/DateRangePopup";
import DateRangeSection from "./Views/DateRangeSection";
import DialogSection from "./Views/DialogSection";
import IconButtonSection from "./Views/IconButtonSection";
import ImageSection from "./Views/ImageSection";
import InputFieldSection from "./Views/InputFieldSection";
import LinkSection from "./Views/LinkSection";
import PopoverSection from "./Views/PopoverSection";
import SelectInput from "./Views/SelectInput";
import Sidebar from "./Views/sidebar/Sidebar";
import TabsSection from "./Views/TabsSection";
import ToastrSection from "./Views/ToastrSection";
import ToggleSwitchSection from "./Views/ToggleSwitchSection";
import TooltipSection from "./Views/TooltipSection";
import TypographySection from "./Views/TypographySection";

const App = () => {
	const [theme, setTheme] = useState("light");
	useEffect(() => {
		const activeTheme = localStorage.getItem("theme") || "light";
		document.body.setAttribute("theme", activeTheme); // setting default theme
		setTheme(activeTheme);
	}, []);
	const handleClickTheme = () => {
		const newTheme = theme === "light" ? "dark" : "light";
		document.body.setAttribute("theme", newTheme); // = newTheme;
		// document.body.classList.add(theme === "light" ? "dark" : "light");
		setTheme(newTheme);
		localStorage.setItem("theme", newTheme);
	};
	const handleClickVersion = () => {
		window.open("https://www.npmjs.com/package/payzli-ui", "_blank");
	};
	return (
		<Router>
			<div className="App">
				<header className="App-header">
					<img src={APP_LOGO} loading="lazy" className="app_logo" alt={"Payzli UI Library"} width="85px" height={"35px"} />
					<div className="d-flex justify-content-end gap2">
						<Button variant={"secondary"} label={`v${packageJson.version}`} onClick={handleClickVersion} />
						<IconButton onClick={handleClickTheme} variant={"secondary"} buttonType="text">
							{theme !== "dark" ? <i className="ph-fill ph-moon"></i> : <i className="ph-fill ph-sun"></i>}
						</IconButton>
						<Avatar size={"md"} src_text={"Payzli"} id={""} image_hash={""} mime_type={""} />
					</div>
				</header>
				<div className="App-body">
					<Sidebar />
					<div className="content-body">
						<Routes>
							<Route path={"/"} element={<ButtonSection />} />
							<Route path={enumRoutes.image} element={<ImageSection />} />
							<Route path={enumRoutes.modal} element={<DialogSection />} />
							<Route path={enumRoutes.Link} element={<LinkSection />} />
							<Route path={enumRoutes.toggle_switch} element={<ToggleSwitchSection />} />
							<Route path={enumRoutes.calendar} element={<DateRangePopup />} />
							<Route path={enumRoutes.calendar} element={<DateRangeSection />} />
							<Route path={enumRoutes.checkbox} element={<CheckboxSection />} />
							<Route path={enumRoutes.tooltip} element={<TooltipSection />} />
							<Route path={enumRoutes.select} element={<SelectInput />} />
							<Route path={enumRoutes.badge} element={<BadgeSection />} />
							<Route path={enumRoutes.popover} element={<PopoverSection />} />
							<Route path={enumRoutes.input_fields} element={<InputFieldSection />} />
							<Route path={enumRoutes.tabs} element={<TabsSection />} />
							<Route path={enumRoutes.buttons} element={<ButtonSection />} />
							<Route path={enumRoutes.icon_buttons} element={<IconButtonSection />} />
							<Route path={enumRoutes.breadcrumbs} element={<BreadcrumbSection />} />
							<Route path={enumRoutes.accordion} element={<AccordionSection />} />
							<Route path={enumRoutes.avatar} element={<AvatarSection />} />
							<Route path={enumRoutes.avatar_group} element={<AvatarGroupSection />} />
							<Route path={enumRoutes.cards} element={<CardSection />} />
							<Route path={enumRoutes.typography} element={<TypographySection />} />
							<Route path={enumRoutes.toastr} element={<ToastrSection />} />

							<Route path="*" element={<ButtonSection />} />
						</Routes>
					</div>
				</div>
			</div>
		</Router>
	);
};

export default App;
